<script setup lang="ts">
import { ref } from "vue";
import { useToast } from "primevue/usetoast";

const props = defineProps<{
  text: string;
  displayText?: string;
  prefix?: string;
}>();

const toast = useToast();
const copying = ref(false);

const copyToClipboard = async () => {
  copying.value = true;
  try {
    await navigator.clipboard.writeText(props.text);
    toast.add({ severity: "success", summary: "Copied!", life: 2000 });
  } catch (err) {
    toast.add({ severity: "error", summary: "Failed to copy", life: 2000 });
  }
  setTimeout(() => {
    copying.value = false;
  }, 1000);
};
</script>

<template>
  <Button
    :label="displayText || `${prefix ?? ''}${text}`"
    link
    @click="copyToClipboard"
    :icon="copying ? 'pi pi-check' : 'pi pi-copy'"
    :class="['hover:text-primary transition-colors']"
  />
</template>
